import React, { useEffect, useMemo } from "react";
import classnames from "classnames";
import { nanoid } from "nanoid";
import styles from "./AddDocumentModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment";

import ObjectSelect from "ManagementTeam/Shared/ObjectSelect";
import Button from "shared/Button";
import DatePicker from "ManagementTeam/Shared/DatePicker";
import TextEditor from "ManagementTeam/Shared/TextEditor";
import { useRef, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { markdownParse } from "ManagementTeam/utils/markdownParse";

import PDFIcon from "ManagementTeam/Shared/ViewPdfButton/pdf_Icon.png";
import { ReactComponent as RemoveButtonImg } from "../../assets/Edit_Category_Remove.svg";
import { MdOutlineEdit } from "react-icons/md";
import DatePickerCalendar from "ManagementTeam/CalendarPage/DatePickerCalendar";
import Toggler from "ManagementTeam/Shared/Toggler";
import { toTitleCase } from "shared/@utils/formatString";

/**
 *
 * Modal when adding / editing document
 *
 */

export function AddDocumentModal({
  isOpen,
  onClose,
  onSave,
  onSaveDraft,
  onPublish,
  document,
  agendaItems,
  meetings,
  itemOwners,
  currentUser,
  isReview,
  meetingType,
}) {
  const id = nanoid();
  const renderIdRef = useRef(nanoid())
  // console.log("AddDocumentModal rerender", renderIdRef.current)

  const [documentItem, setDocumentItem] = useState(document || { files: [] });
  const [tempDocuments, setTempDocuments] = useState(
    document && document.files
      ? document.files.map((document, index) => {
        return { id: timeId() + index, document: document, deleted: false };
      })
      : []
  );
  const [notes, setNotes] = useState(document ? document.notes : []);
  const [owners, setOwners] = useState([]);
  const [dates, setDates] = useState([]);
  const [agendas, setAgendas] = useState([]);
  const [filteredAgendas, setFilteredAgendas] = useState([]);
  const [meetingId, setMeetingId] = useState(null);
  const [agendaId, setAgendaId] = useState(null);
  const [documentItemOwner, setDocumentItemOwner] = useState(null);
  const [title, setTitle] = useState(document ? document.title : "");
  const [description, setDescription] = useState("");
  const [tempNote, setTempNote] = useState("");
  const [addToThisMeeting, setAddToThisMeeting] = useState(null);
  const [addToThisAgenda, setAddToThisAgenda] = useState(null);
  const [errors, setErrors] = useState({});

  const [dateOneCalendarOpen, setDateOneCalendarOpen] = useState(false);

  const meetingDates = useMemo(() => {
    return [...meetings];
  }, [meetings]);

  useEffect(() => {
    document && setDocumentItem(document);
  }, [document]);

  useEffect(() => {
    if (document) {
      var findMeeting = agendaItems.filter(
        (item) =>
          item.agenda.filter((agendaItem) =>
            document.agenda ? agendaItem.id === document.agenda.id : true
          ).length > 0
      );
      var agendas = findMeeting.length > 0 ? findMeeting[0].agenda : [];
      setDocumentItem(document);
      setNotes(document.notes);
      setTitle(document.title);
      setDescription(document.description);
      setDocumentItemOwner({
        id: document.owner._id,
        option: document.owner.name,
      });
      setMeetingId(
        document.agenda && findMeeting.length > 0
          ? findMeeting[0].meetingId
          : ""
      );
      setAddToThisMeeting(
        document.agenda && findMeeting.length > 0
          ? meetings.find((meeting) => meeting.id === findMeeting[0].meetingId)
          : ""
      );
      setAgendaId(document.agenda ? document.agenda.id : null);
      var selectedAgenda = document.agenda
        ? agendas.find((agenda) => agenda.id === document.agenda.id)
        : null;
      setAddToThisAgenda(selectedAgenda ? selectedAgenda.title : "");
    } else {
      //reset form
      setTempDocuments([]);
      setNotes([]);
      setOwners([]);
      setAgendas([]);
      setFilteredAgendas([]);
      setMeetingId(null);
      setAgendaId(null);
      setDocumentItemOwner(null);
      setTitle("");
      setDescription("");
      setTempNote("");
      setAddToThisMeeting(null);
      setAddToThisAgenda(null);
      setDateOneCalendarOpen(false);
      setDocumentItem(null);
    }
  }, [document]);

  // populate list of possible item owners
  useEffect(() => {
    itemOwners && setOwners(itemOwners);
  }, [itemOwners]);

  // populate list of meeting dates
  useEffect(() => {
    if (meetings) {
      setDates([
        {
          option: "Remove from This Meeting",
          id: -2,
        },
        ...meetings,
      ]);
    }
  }, [meetings]);

  // create list of agendas to filter by date
  useEffect(() => {
    agendaItems && setAgendas(agendaItems);
  }, [agendaItems]);

  // set filtered agenda list to agendas by meeting date
  useEffect(() => {
    var agendaOptions = [];
    var agendaClone = [...agendas];
    var agendaByMeeting = agendaClone.filter(
      (agenda) => agenda.meetingId === meetingId
    );
    if (agendaByMeeting.length > 0) {
      agendaOptions = agendaByMeeting[0].agenda.map((agenda) => {
        return {
          option: agenda.title,
          id: agenda._id,
        };
      });

      if (addToThisAgenda) {
        agendaOptions.unshift({
          option: "Remove from This Agenda",
          id: -2,
        });
      }
    }
    setFilteredAgendas(agendaOptions);
  }, [meetingId, agendas]);

  const fileRef = useRef(null);
  const noteRef = useRef(null);

  const todaysDate = new Date();
  const [date, setDate] = useState(
    document
      ? moment(document.submittedOn).format("M.D.YYYY")
      : todaysDate.getMonth() +
      1 +
      "." +
      todaysDate.getDate() +
      "." +
      (todaysDate.getUTCFullYear() - 2000)
  );

  const handleSave = (type) => {
    // error check validation
    var _errors = {};

    if (!title || title.length < 1)
      _errors["title"] = "* Please enter a title.";

    if (!documentItemOwner)
      _errors["owner"] = "* Please select an owner.";

    if (!documentItem || documentItem.length < 1)
      _errors["document"] = "* Please Attach a Document.";

    if (!_errors || Object.keys(_errors).length > 0) {
      setErrors(_errors);
      return;
    }

    const formData = {
      meetingType: meetingType,
      title: title ? title : "",
      owner: {
        _id: documentItemOwner ? documentItemOwner.id : null,
        name: documentItemOwner ? documentItemOwner.option : null,
      },
      description: description ? description : "",
      agendaId: agendaId ? agendaId : null,
      notes: notes
        ? notes.map((note) => (note.content ? note.content : ""))
        : [],
      isDraft: type === "save" ? false : true,
      isReview: isReview,
      fileToUpload: documentItem.files && documentItem.files.length > 0 ? documentItem.files[0] : null,
      isDownloadable: documentItem.isDownloadable,
      submittedOn: new Date(date.replaceAll(".", "/")).toISOString(),
    };

    type === "save" ? onSave(formData) : onSaveDraft(formData);

    return;
  }

  const handlePublish = (isDraft) => {
    onPublish && onPublish({
      id: document.id,
      isDraft: isDraft
    });
  }

  const handleToggleDownloadable = () => {
    if (!documentItem) {
      return;
    }

    documentItem.isDownloadable = !documentItem.isDownloadable;
    setDocumentItem({ ...documentItem })
  }

  const handleClose = () => {
    setErrors({});
    onClose();
  }

  function toggleDateOneCalendar() {
    if (dateOneCalendarOpen) {
      setDateOneCalendarOpen(false);
    } else {
      setDateOneCalendarOpen(true);
    }
  }

  function formatDate(date) {
    return (
      date.getUTCMonth() +
      1 +
      "." +
      date.getUTCDate() +
      "." +
      (date.getUTCFullYear() - 2000)
    );
  }

  return (
    isOpen
      ? <div className={styles.container}>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderRightReverse}>
            <Button
              className={styles.cancelButton}
              children="Cancel"
              onClick={() => handleClose()} />
            <Button
              className={styles.saveButton}
              children="Save"
              onClick={() => handleSave("save")} />
            {!document && <Button
              className={styles.saveAsDraftButton}
              children="Save As Draft"
              onClick={() => handleSave("draft")} />}
          </div>
          {document && <div className={styles.modalHeaderLeftReverse}>
            {!document.isDraft
              ? <Button
                className={classnames(styles.unpublishedButton, styles.makeUnpublished)}
                children="Unpublished"
                onClick={() => handlePublish(true)} />
              : <span className={classnames(styles.unpublishedButton, styles.isUnpublished)}>Unpublished</span>}
            {document.isDraft
              ? <Button
                className={classnames(styles.publishedButton, styles.makePublished)}
                children="Published"
                onClick={() => handlePublish(false)} />
              : <span className={classnames(styles.publishedButton, styles.isPublished)}>Published</span>}
          </div>}
        </div>
        <div className={styles.modalBody}>
          <div className={styles.leftSide}>
            <div className={styles.label}>Date</div>
            <div>
              <div
                className={classNames(
                  styles.dateOneCalendar,
                  !dateOneCalendarOpen && styles.displayNone
                )}
              >
                <DatePickerCalendar
                  selectedDate={date ? date : formatDate(new Date())}
                  changeSelectedDate={(e) => setDate(formatDate(new Date(e)))}
                />
              </div>
              <DatePicker
                dateString={date ? date : formatDate(new Date())}
                setDate={setDate}
                toggleCalendar={toggleDateOneCalendar}
              />
            </div>

            <div className={styles.label}>
              Document Item Owner
              {errors.owner && (
                <span className={styles.error}>{errors.owner}</span>
              )}
            </div>
            <div className={styles.selectContainer}>
              <ObjectSelect
                placeholder={
                  documentItemOwner ? documentItemOwner.option : "Select Owner"
                }
                selectedOption={
                  documentItemOwner ? documentItemOwner.option : "Select Owner"
                }
                options={owners}
                onChange={(e) => {
                  var newOwner = owners.find((owner) => owner.id === e);
                  setDocumentItemOwner(newOwner);
                }}
                className={styles.select}
                formatDisplayOption={toTitleCase}
              />
            </div>
            <div className={styles.label2}>
              Document Title
              {errors.title && (
                <span className={styles.error}>{errors.title}</span>
              )}
            </div>

            <input
              type="text"
              className={styles.input}
              value={title}
              placeholder="Document Title"
              onChange={(e) => setTitle(e.target.value)}
            />

            <div className={styles.label}>
              Description
              {errors.description && (
                <span className={styles.error}>{errors.description}</span>
              )}
            </div>
            <div className={styles.descriptionContainer}>
              <TextEditor text={description} setText={setDescription} />
            </div>

            <div className={styles.label}>Notes</div>
            <div className={styles.notesContainer}>
              <TextEditor text={tempNote} setText={setTempNote} />
              <div className={styles.btnContainer}>
                <Button
                  className={styles.addButton}
                  onClick={() => {
                    if (tempNote !== "") {
                      setNotes([
                        {
                          author: currentUser,
                          date: currentTime(),
                          content: tempNote,
                        },
                        ...notes,
                      ]);
                      setTempNote("");
                      noteRef.current.scroll({ top: 0, behavior: "smooth" });
                    }
                  }}
                  children={<p>Add Note</p>}
                />{" "}
              </div>
            </div>
            <div>
              <div>
                <div ref={noteRef} className={styles["note-container"]}>
                  {notes && notes.length ? (
                    <TransitionGroup component="ul">
                      {notes &&
                        notes.map((note, index) => (
                          <CSSTransition
                            timeout={300}
                            classNames={{
                              enterActive: styles["fade-enter-active"],
                              enter: styles["fade-enter"],
                              exit: styles["fade-exit"],
                              exitActive: styles["fade-exit-active"],
                            }}
                            key={notes && notes.length - index}
                          >
                            <li>
                              <div className={styles["note-body"]}>
                                <p className={styles["note-author"]}>
                                  {note.author
                                    ? note.author
                                    : note.postedBy.name
                                      ? note.postedBy.name
                                      : ""}
                                </p>
                                <p className={styles["note-date"]}>
                                  {note.date
                                    ? note.date
                                    : note.submittedOn
                                      ? moment(note.submittedOn)
                                        .format("LLL")
                                        .replace("AM", "a.m.")
                                        .replace("PM", "p.m.")
                                      : ""}
                                </p>
                                <p className={styles["note-content"]}>
                                  {markdownParse(
                                    note.content
                                      ? note.content
                                      : note.note
                                        ? note.note
                                        : ""
                                  )}
                                </p>
                              </div>
                            </li>
                          </CSSTransition>
                        ))}
                    </TransitionGroup>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.rightSide}>
            <div>
              <div
                className={classNames(
                  styles["horizontal-line"],
                  styles.documents
                )}
              >
                Documents
                {errors.document && (
                  <span className={styles.error}>{errors.document}</span>
                )}
              </div>

              <ul className={styles["documents-list"]}>
                {/* <TransitionGroup> */}
                {tempDocuments
                  .filter((document) => !document.deleted)
                  .map((document, index) => (
                    <li className={styles["pdf-li"]} key={index}>
                      <img src={PDFIcon} alt="" />
                      <p>{document.document.name || document.name}</p>
                      <button
                        type="button"
                        className={styles["remove-button"]}
                        onClick={() => {
                          setDocumentItem({});
                          setTempDocuments([]);
                        }}
                      >
                        <RemoveButtonImg />
                      </button>
                    </li>
                    // </CSSTransition>
                  ))}
                {documentItem && <div>
                  <div className={styles.documentsDownload}>
                    <span>Document is Downloadable</span>
                    <div className={styles.documentsDownloadToggle}>
                      <Toggler
                        visible={true}
                        onChange={() => handleToggleDownloadable()}
                        toggled={documentItem.isDownloadable}
                        color={documentItem.isDownloadable ? "#39B54A" : "#D3D3D3"}
                        key={id}
                      />
                    </div>
                  </div>
                  <div className={styles["documents-line"]} />
                </div>}
                {/* </TransitionGroup> */}
              </ul>
              <label htmlFor="pdf-input" hidden>
                PDF Document
              </label>

              <input
                hidden
                ref={fileRef}
                type="file"
                name="pdf-input"
                accept="application/pdf"
                onChange={(e) => {
                  /* PDF Validation */

                  let selectedFile = e.target.files;
                  const fileName = fileRef.current.value.split(".");

                  if (fileName[fileName.length - 1] === "pdf") {
                    var file = null;
                    let fileToLoad = selectedFile[0];
                    let fileReader = new FileReader();
                    fileReader.onload = function (fileLoadedEvent) {
                      file = fileLoadedEvent.target.result;
                      // Print data in console
                      setDocumentItem({
                        ...documentItem, files: [{
                          name: fileName[0].replace(/^.*[\\/]/, ""),
                          data: file,
                          mimetype: "pdf",
                        }],
                        isDownloadable: true
                      });
                    };

                    // Convert data to base64
                    fileReader.readAsDataURL(fileToLoad);

                    setTempDocuments([
                      {
                        id: timeId(),
                        document: fileRef.current.value,
                        deleted: false,
                        name: fileName[0].replace(/^.*[\\/]/, ""),
                      },
                      ...tempDocuments,
                    ]);
                  } else {
                    alert("File Format not PDF");
                  }
                  fileRef.current.value = "";
                }}
              />
              {/* allow only 1 file for now*/}
              {tempDocuments.filter((a) => !a.deleted).length == 0 && (
                <Button
                  className={classNames(
                    styles["add-button"],
                    styles["document-button"]
                  )}
                  onClick={() => {
                    fileRef.current.click();
                  }}
                  children={<p>Add</p>}
                />
              )}
            </div>

            <div className={classNames(styles.label, styles.rightTopSpacing)}>
              Add to This Meeting
            </div>
            <div className={styles.selectContainer}>
              <ObjectSelect
                placeholder={
                  addToThisMeeting ? addToThisMeeting.option : "Choose"
                }
                selectedOption={
                  addToThisMeeting ? addToThisMeeting.option : "Choose"
                }
                options={meetingDates}
                onChange={(e) => {
                  if (e == -2) {
                    setAgendaId(null);
                    setAddToThisAgenda(null);
                    setAddToThisMeeting(null);
                    setMeetingId(null);
                  } else {
                    var newDate = dates.find((date) => date.id === e);
                    if (newDate) {
                      setAddToThisMeeting(newDate);
                      setMeetingId(newDate.id);
                    } else {
                      setAddToThisMeeting(null);
                      setMeetingId(null);
                    }
                  }
                }}
                className={styles.select}
              />
            </div>
            <div className={styles.label}>
              Add to This Agenda Item
              {errors.agenda && (
                <span className={styles.error}>{errors.agenda}</span>
              )}
            </div>
            <div className={styles.selectContainer}>
              <ObjectSelect
                disabled={!addToThisMeeting}
                placeholder={
                  addToThisMeeting && addToThisAgenda
                    ? addToThisAgenda
                    : addToThisMeeting && !addToThisAgenda
                      ? "Choose"
                      : "(Select a Meeting First)"
                }
                selectedOption={
                  addToThisMeeting && addToThisAgenda
                    ? addToThisAgenda
                    : addToThisMeeting && !addToThisAgenda
                      ? "Choose"
                      : "(Select a Meeting First)"
                }
                options={filteredAgendas}
                onChange={(e) => {
                  if (e == -2) {
                    setAgendaId(null);
                    setAddToThisAgenda(null);
                    setAddToThisMeeting(null);
                    setMeetingId(null);
                  } else {
                    var newAgenda = filteredAgendas.find(
                      (agenda) => agenda.id === e
                    );
                    if (newAgenda) {
                      setAgendaId(e);
                      setAddToThisAgenda(newAgenda.option);
                    }
                  }
                }}
                className={styles.select}
              />
            </div>
          </div>
        </div>
      </div>
      : ""
  )
}

export const AddDocumentModalMemo = React.memo(AddDocumentModal, (prev, next)=>{
  // console.log("prev and next", prev, next)
  return prev.id == next.id
})

const currentTime = () => {
  const current = new Date();
  return `${current.toLocaleDateString("en-us", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })} ${current
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    })
    .replace("AM", "a.m.")
    .replace("PM", "p.m.")}`;
};

const timeId = () => new Date().getTime();

AddDocumentModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onSaveDraft: PropTypes.func,
  document: PropTypes.object,
};
